<template>
  <section id="features" class="flex justify-center items-center py-10 my-10 relative w-full leading-relaxed">

    <div class="flex flex-col items-center justify-center py-6 w-full max-w-7xl relative">

      <div id="what-is-decast"
        class="box-wrapper justify-between items-center py-16 lg:px-20 lg:py-24 p-8 lg:gap-8 gap-4 overflow-hidden relative rounded-2xl bg-dark-black">
        <div class="absolute w-full h-fit flex justify-start items-start z-0 top-0">
          <svg class="top-0 absolute w-full h-fit" width="1280" height="668" viewBox="0 0 1280 668" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.2" width="1280" height="668" fill="url(#paint0_radial_468_9965)" />
            <defs>
              <radialGradient id="paint0_radial_468_9965" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                gradientTransform="translate(640 -361.807) rotate(90) scale(877.838 1682.09)">
                <stop stop-color="#D7DF23" stop-opacity="0.1" />
                <stop offset="1" />
              </radialGradient>
            </defs>
          </svg>
        </div>
        <div class="w-full flex flex-col items-start gap-6 justify-start lg:col-span-6 col-span-full">
          <!-- <p class="text-primary text-base font-normal">// What is Decast?</p> -->
          <h4 class="text-white lg:text-5xl text-4xl font-bold ">
            Streaming is transient // Casting is intentional.
          </h4>
          <p class="text-xl font-normal text-white opacity-60 montserrat">
            Where streaming ends with a transmission, Casting is a secure, multi-layered publishing flow
          </p>
        </div>

        <!-- Features Grid -->
        <div class="w-full mt-20">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-20">
            <div v-for="feature in features" :key="feature.title"
              class="feature-card rounded-lg border border-white border-opacity-25">
              <h5 class="text-white text-xl font-bold mb-1">{{ feature.title }}</h5>
              <p class="text-white opacity-60 text-base montserrat">
                {{ feature.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhatIsDecast',
  data() {
    return {
      features: [
        {
          title: 'Capture once',
          description: 'via live camera, voice stream, screen share or play documents live'
        },
        {
          title: 'Assisted with AI',
          description: 'transcriptions, caption, summaries in real time, with AI post-productions'
        },
        {
          title: 'Multi-Cast',
          description: 'Publish to platforms like YouTube, Twitch, private nodes etc.'
        },
        {
          title: 'Cryptographic signatures',
          description: 'store & prove with decentralized storages and verifiable meta-data'
        },
        {
          title: 'Indexed for Information',
          description: 'Auto-tag content with metadata, topics, participants for quick retrieval.'
        },
        {
          title: 'Identity and IP',
          description: 'Secured by DIDs, searchable by episodes, or case IDs.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.box-wrapper {
  border: 0.5px solid #ffffff80;
  margin-top: 12px;

}
</style>
